export default __webpack_public_path__ + "media/images/features/local_delivery/episode5/LP_02-e62031f6f829d2b24b252a2972470495.jpeg";